if (navigator.serviceWorker && process.env.PLATFORM !== 'local' && !/\/m\/mkt\/download/.test(location.pathname)) {
  window.addEventListener('load', function () {
    navigator.serviceWorker
      .register('/sw2.js', { scope: '/' })
      .then(() => console.log('sw2 has been registered'))
      .catch((e) => console.warn('Registration failed with ' + e))
  })
}
